const $iTest = $('.test-images').first();
const dataViewRight = $iTest.attr('data-view-right');
let viewRight = false;
const sQuestion = '.img-test';
const cQuestionAnswered = 'img-test_answered';
const cAnswerRight = 'img-test__pic_right';
const cAnswerFail = 'img-test__pic_fail';
const cAnswerNoSelect = 'img-test__pic_noselect';
const cAnswerSelect = 'img-test__pic_select';
const sAnswer = '.img-test__pic';
const sComment = '.img-test__note';
const cCommentActive = 'img-test__note_active';
const $resultCont = $iTest.find('.test-images__result-cont');

if (typeof dataViewRight === 'string' && dataViewRight === 'Y') {
    viewRight = true;
}

if ($iTest.length) {
    const $answer = $iTest.find(sAnswer);

    $answer.on('click', function (e) {
        const $question = $(this).closest(sQuestion);
        const $answers = $question.find(sAnswer);
        const q = parseInt($(this).attr('data-question'));
        const a = $(this).attr('data-answer');

        e.preventDefault();

        if ($question.length && q && a) {
            if (!$question.hasClass(cQuestionAnswered)) {
                $answers.not($(this)).addClass(cAnswerNoSelect);
                $(this).addClass(cAnswerSelect);

                $.post('./', { action: 'is_right', q }, (data) => {
                    const json = JSON.parse(data);
                    let isFinish = true;

                    for (let i = 0; i < json.length; i++) {
                        const item = json[i];

                        if (viewRight) {
                            if (a === item.A || item.R === 1) {
                                const $itemA = $answers.filter(`[data-answer=${item.A}]`);

                                if (item.R === 1) {
                                    $itemA.removeClass(cAnswerNoSelect).addClass(cAnswerRight);
                                } else {
                                    $itemA.removeClass(cAnswerNoSelect).addClass(cAnswerFail);
                                }
                            }

                            if (a === item.A && item.COMMENT !== '') {
                                $question.find(sComment).html(item.COMMENT).addClass(cCommentActive);
                            }
                        }
                    }

                    $question.addClass(cQuestionAnswered);

                    if ($iTest.find(sQuestion).not(`.${cQuestionAnswered}`).length) {
                        isFinish = false;
                    }

                    if (isFinish) {
                        const ANSWERS = {};

                        $resultCont.html('<div class="test-images__loader"><div class="loader loader_center loader_orange"><div class="loader__cont"><svg class="loader__svg"><use xlink:href="#loader"></use></svg></div></div></div>');

                        $iTest.find(`.${cAnswerSelect}`).each(function () {
                            ANSWERS[parseInt($(this).attr('data-question'))] = parseInt($(this).attr('data-answer'));
                        });

                        $.post('./', { action: 'finish', ANSWERS }, (d) => {
                            $resultCont.html(d);
                        });
                    }
                });
            }
        }
    });
}